module.exports = __webpack_public_path__ + "img/FachadaBristol-4.54b1047e.jpg";